// models
import { Base } from 'app/shared/models/base.model';
import { CalRegTable } from 'app/calibrations/shared/cal-reg-table.model';
import { InstrumentBand } from 'app/instruments/shared/instrument-band.model';

export class CalCriterion extends Base {

  constructor(
    public CriterionDescription?: string,
    public InstrumentBand?: InstrumentBand,
    public MaxErrorLower?: number,
    public MaxErrorMore?: number,
    public Name?: string,
    public Table?: CalRegTable,
    public Type?: EReferenceModeType
  ) {
    super();
  }
}

export enum EReferenceModeType {
  AbsoluteValue = 0,
  PercentAmplitude = 1,
  PercentValueRead = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cal-criterion.model.ts